import { useRef } from "react";
import { assertUnreachable } from "../../utilities/assertUnreachable.js";
import { useQuery } from "./useQuery.js";
const toStaticQueryState = (state)=>{
    switch(state.status){
        case 'loading':
        case 'error':
        case 'loaded':
            return state;
        case 'idle':
            throw new Error('This state should not be possible');
        default:
            throw new Error(assertUnreachable(state));
    }
};
const useStaticQuery = ({ action })=>{
    const { state, retry, fetch } = useQuery({
        action,
        initialQuery: void 0
    });
    return {
        refetch: useRef(()=>fetch(void 0)).current,
        retry,
        state: toStaticQueryState(state)
    };
};
export { useStaticQuery };
